const width = 180
const height = 50

export const baseCardSize = {
    w: width,
    h: height,
    xSpace: 54,
    ySpace: 28,
    xSpace2r: 15,
    ySpace2v: 15,
}

// 转换卡片模板======start
export function getCradConfig(carddimensionIdCardStyleMap) {
    // 默认卡片尺寸
    let cardHeight = -Infinity

    const cardModelMap = {}
    const cardModelHeightMap = {}

    for (const key in carddimensionIdCardStyleMap) {
        if (Object.hasOwnProperty.call(carddimensionIdCardStyleMap, key)) {
            const cardModelItem = carddimensionIdCardStyleMap[key];
            const [maxHeight, fields] = getCardModelMap(cardModelItem.cardStyleFields)

            cardModelHeightMap[key] = maxHeight
            cardModelMap[key] = fields
            cardHeight = Math.max(cardHeight, cardModelHeightMap[key])
        }
    }

    baseCardSize.h = cardHeight

    getCardVModelMap(baseCardSize, cardModelMap)

    return { baseCardSize, cardModelHeightMap, cardModelMap }
}

// 得到卡片模板Map
function getCardModelMap(cardStyleFields) {
    let cardHeight = -Infinity

    const fields = []

    // 添加卡片顶部横条
    // fields.push({
    //     tag: "rect",
    //     x: 0,
    //     y: 0,
    //     w: baseCardSize.w,
    //     h: 2,
    //     fill: () => "#5582F3"
    // })

    cardStyleFields.map(fieldItem => {
        // 文字书写方向布局：start middle end
        const textAnchor = fieldItem.fontjustification === "1" ? "start" : fieldItem.fontjustification === "2" ? "middle" : "end"

        const x = parseInt(fieldItem.xcoordinate)
        const y = parseInt(fieldItem.ycoordinate)
        const w = parseInt(fieldItem.wide)
        const h = parseInt(fieldItem.high)

        const padding = 4

        cardHeight = Math.max(cardHeight, h + y)

        // 字段名称包含‘avtor’:图片字段
        if (fieldItem.fieldidentifier.indexOf("avtor") > -1) {
            // 图片尺寸
            const size = Math.min(w, h) - padding * 2

            fields.push({
                tag: "img",
                x: x + (w - size) / 2,
                y: y + (h - size) / 2,
                w: size,
                h: size,
                textAnchor,
                url: (data) => {
                    const fieldVal = data.showFields ? data.showFields[fieldItem.fieldidentifier] : null
                    return fieldVal ? fieldVal : getDefaultHead(data.showFields)
                },
            })
        } else {
            fields.push({
                tag: "text",
                x: x + padding,
                y: y,
                w: w - padding * 2,
                h: h,
                fontSize: parseInt(fieldItem.wordsize),
                fontWeight: parseInt(fieldItem.bold) ? 600 : 100,
                color: "#212121",
                wMode: "lr",
                valign: "center",
                textAnchor,
                lineNums: 2,
                text: (data) => {
                    let text = ""
                    if (data.showFields) {
                        text = data.showFields[fieldItem.fieldidentifier + ""]
                        text = text === 0 ? "0" : (text || "")
                    }
                    if (fieldItem.fieldidentifier === "establishmentdate") {
                        text = text.substring(0, 10)
                    }
                    return [(fieldItem.beforecontent || "") + text + (fieldItem.aftercontent || "")];
                },
            })
        }
    })

    return [cardHeight, fields]
}

// 得到卡片纵向模板Map
function getCardVModelMap(baseCardSize, cardModelMap) {
    for (const key in cardModelMap) {
        if (Object.hasOwnProperty.call(cardModelMap, key)) {
            const card = cardModelMap[key];
            cardModelMap[key + "V"] = []
            card.map((item, index) => {
                if (index === 0) {
                    cardModelMap[key + "V"].push({
                        tag: "rect",
                        x: 0,
                        y: 0,
                        w: baseCardSize.h,
                        h: 2,
                        fill: () => "#5582F3"
                    })
                } else {
                    cardModelMap[key + "V"].push({
                        ...item,
                        x: item.y,
                        y: item.x,
                        w: item.h,
                        h: item.w,
                        wMode: "tb",
                        valign: transValign(item.textAnchor),
                        textAnchor: transTextAnchor(item.valign),
                    })
                }
            })
        }
    }
}

// 转换样式
function transValign(textAnchor) {
    switch (textAnchor) {
        case "start":
            return "top"
        case "middle":
            return "center"
        case "end":
            return "bottom"
    }
}

// 转换样式
function transTextAnchor(valign) {
    switch (valign) {
        case "top":
            return "start"
        case "center":
            return "middle"
        case "bottom":
            return "end"
    }
}

function getDefaultHead(showFields) {
    if (showFields.hasMorePrimaryPerson == 1) {
        return window.__kd_cdnPath__ + "/kingdee/hr/kdchart2station/css/image/heads.png"
    }
    return window.__kd_cdnPath__ + "/kingdee/hr/kdchart2station/css/image/d_head.png"
}
// 转换卡片模板======end


// kdchart回调：获取卡片模板
export function getCardModel(node, customParams) {
    let cardModel = node.data.otclassify

    if (customParams.rotateLevel >= 0 && node.data.level >= customParams.rotateLevel) {
        cardModel += "V"
    }

    return cardModel
}
// kdchart回调：获取卡片尺寸
export function getCardSize(node, customParams, cardModelHeightMap) {
    return baseCardSize
    const cardSize = {
        ...baseCardSize,
        h: cardModelHeightMap[(node?.cardModel ?? "").replace("V", "")]
    }

    console.log("cardSize", cardSize);

    if (customParams.rotateLevel < 0) {
        return cardSize
    } else {
        if (node.data.level >= customParams.rotateLevel) {
            return {
                ...cardSize,
                h: cardSize.w,
                w: cardSize.h
            }
        } else {
            return cardSize
        }
    }
}
// kdchart回调：获取卡片样式
export function getCardStyle(node) {
    return {
        // background: "#5582f3",
        background: "#f4f8fe",
        // background: "rgba(85, 130, 243, 0.05)",
        // opacity: 0.05,
        border: "#5582f3",
        // border: "rgb(85, 130, 243)",
        borderType: "",
        radius: 2
    }
}


// 导出配置=====start
export function getDownConfig(kdchart, altImg) {
    const chartData = kdchart.chartDataApp.chartData
    const nodeList = []
    const linkList = []

    each(chartData)

    function each(root) {
        nodeList.push(getDownNode(root))

        if (root.children && root.children.length > 0) {
            root.children.map(child => {
                linkList.push({
                    source: getDownNode(root),
                    target: getDownNode(child)
                })
                each(child)
            })
        }
    }

    const { cardModelMap, maxLoc, minLoc } = kdchart.mainViewApp
    const { baseCardSize, direction, customParams: { rotateLevel } } = kdchart
    const rootNode = getDownNode(chartData)

    return {
        nodeList,
        linkList,
        rootNode,
        cardModelMap,
        maxLoc,
        minLoc,
        baseCardSize,
        direction,
        altImg,
        rotateLevel
    }

}

function getDownNode(node) {
    return {
        id: node.id,
        cardSize: { ...node.cardSize },
        cardStyle: { ...node.cardStyle },
        data: {
            id: node.id,
            showFields: { ...node.data.showFields },
        },
        isLeaf: node.data.isLeaf || 0,
        childLoadType: node.data.childLoadType || 0,
        load2type: node.data.load2type || 0,
        level: node.data.level,
        cardModel: node.cardModel,
        x: node.x,
        y: node.y,
    }
}
// 导出配置=====end


// 卡片按钮等配置
// 折叠按钮
export const iconConfig = {
    fontSize: 16,
    toogleMinus: {
        unicode: "&#xecb8;",
        color: "#666",
    },
    tooglePlus: {
        unicode: "&#xecb9;",
        color: "#666",
    },
    className: "kdfont",
}
// 悬浮按钮
export const hoverMenuModels = [
    {
        tag: "rect",
        x: 0,
        y: 0,
        w: 24,
        h: 24,
        rx: 1.38,
        fill: "#fff",
        stroke: "#ccc"
    },
    {
        tag: "icon",
        id: "descLink",
        x: 4,
        y: 9,
        w: 16,
        h: 16,
        fontSize: 12,
        fill: "#38f",
        text: "&#xe76d;",
        class: "kdfont",
        click: (kdchart, currNode) => {
            kdchart.routeEvent({
                eventName: "linkCardDetail",
                currNode,
            })
        }
    }
]
// 预览图横条颜色
export const preViewCardModelMap = {
    "1010": "#5582F3",
    "1010V": "#5582F3",
    "1020": "#f00",
    "1020V": "#f00",
}

export function debounce(func, wait = 200, immediate = true) {
    var timeout;

    return function () {
        var context = this;
        var args = arguments;

        if (timeout) clearTimeout(timeout);
        if (immediate) {
            var callNow = !timeout;
            timeout = setTimeout(function () {
                timeout = null;
            }, wait)
            if (callNow) func.apply(context, args)
        }
        else {
            timeout = setTimeout(function () {
                func.apply(context, args)
            }, wait);
        }
    }
}